import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { StandaloneContainerComponent } from 'src/app/components/standalone/standalone-container/standalone-container.component';
import { StandaloneRoutingModule } from './standalone-routing.module';
import { CommercialPurposeClauseComponent } from 'src/app/components/commercial-purpose-clause/commercial-purpose-clause.component';
import { ComplaintTopicComponent } from 'src/app/components/complaint-topic/complaint-topic.component';
import { ComplaintResponseComponent } from 'src/app/components/complaint-response/complaint-response.component';

@NgModule({
  declarations: [
    StandaloneContainerComponent
  ],
  imports: [
    CommonModule,
    StandaloneRoutingModule,
    SharedModule
  ],
  entryComponents: [
    CommercialPurposeClauseComponent,
    ComplaintTopicComponent,
    ComplaintResponseComponent
  ]
})
export class StandaloneModule { }
